<script>
  import { getEnvironments } from "../utils/environments";
  import { isWalletConnectDesktopLink } from "../utils/queryString";
  import { ButtonGroup, ButtonGroupItem } from "svelte-materialify";

  const activeEnvSubdomain = location.hostname.split(".")[0];

  const redirect = (env) => {
    const port = location.port ? `:${location.port}` : "";
    const urlParams = new URLSearchParams(location.search);
    const nextParam = urlParams.get('next');
    const decodedNextParam = decodeURIComponent(nextParam);
    const newUrl = `${location.protocol}//${env.hostname}${port}${decodedNextParam}`;
    window.location.assign(newUrl);
  };

  const isDisabled = (subdomain) => {
    return subdomain === activeEnvSubdomain ? "true" : "false";
  };

  const environments = getEnvironments().map((envHostname) => ({
    subdomain: envHostname.split(".")[0],
    hostname: envHostname,
  }));

  let value = environments.findIndex(
    (env) => env.subdomain === activeEnvSubdomain
  );
</script>

{#if environments.length > 1 && isWalletConnectDesktopLink()}
  <div class="banner">Choose an environment:</div>
  <div class="envSelectorContainer">
    <div>
      <ButtonGroup
        borderless
        bind:value
        class="rounded-corner-xl"
        activeClass="blue lighten-4"
      >
        {#each environments as env}
          <ButtonGroupItem on:click={() => redirect(env)}
            >{env.subdomain}</ButtonGroupItem
          >
        {/each}
      </ButtonGroup>
    </div>
  </div>
{/if}

<style>
  .envSelectorContainer {
    justify-content: center;
    align-content: center;
    display: flex;
    margin-top: 10px;
    font-family: Heebo;
    margin-bottom: 20px;
  }

  .banner {
    margin-top: 10px;
    width: 454px;
    height: 24px;
    /* Body 2 */
    /* identical to box height, or 24px */
    text-align: center;
    letter-spacing: 0.02em;

    /* Shades/Shade 4 */
    color: #545360;
    font-family: Heebo;
    display: inline-block;
  }
</style>
